import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import {ethers} from "ethers";
import {
  stakedTokenABI,
  stakedTokenAddress,
} from "../../contracts/StakingTokenABI";
import {StakingAddress, StakingABI} from "../../contracts/StakingInformation";

export const fetchStakingContract = createAsyncThunk(
  "stackingContract/fetchStakingContract",
  async (params, {dispatch, getState, rejectWithValue}) => {
    try {
   const { provider} = params
       console.log(provider,"prov")
        const stakingContract = new ethers.Contract(
          StakingAddress,
          StakingABI,
          provider
        );
        return stakingContract;
      
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const fetchStakingContractWithUser = createAsyncThunk(
  "stackingContract/fetchStakingContractWithUser",
  async ({provider}, {dispatch, getState, rejectWithValue}) => {
    try {
    
        const signer = provider.getSigner();
        const stakingContractWithUser = new ethers.Contract(
          StakingAddress,
          StakingABI,
          signer
        );
        return stakingContractWithUser;
      
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const getAllStakingPools = createAsyncThunk(
  "stackingContract/getAllStakingPools",
  async (_, {dispatch, getState, rejectWithValue}) => {
    try {
      let tempPoolItem = {};
      const newPool = [];
      const stakingContract = getState().stakingSlice.contract;
      const allStakingPoolLength = await stakingContract?.poolLength();
      const arr = [];
      for (let k = 0; k < allStakingPoolLength.toString(); k++) {
        arr.push(k);
      }
      for await (let i of arr) {
        //const poolItem = await stakingContract?.poolInfo(i);
        const poolItem = await stakingContract?.poolInfo(i);
        //tempPoolItem = {...poolItem, id: i, isFixed: false};
        const tempPool = {...poolItem, id: i, isFixed: true};
        //newPool.push({...tempPoolItem});
        newPool.push({...tempPool});
      }
      console.log("newPool", newPool);
      return newPool;
    } catch (err) {
      console.log(err)
      return rejectWithValue(err);
    }
  }
);

export const getContractUserInfo = createAsyncThunk(
  "stackingContract/getContractUserInfo",
  async (params, {dispatch, getState}) => {
    const {stackingPoolId, account, isFixed, value} = params;

    try {
      const stakingContract = getState().stakingSlice.contract;
      if (isFixed) {
        const stackingUserInfo = await stakingContract?.userInfo(
          stackingPoolId,
          account
        );
        const modifiedUserInfo = {
          ...stackingUserInfo,
          id: stackingPoolId,
          isFixed,
          amount: value ? value : stackingUserInfo.amount,
        };

        dispatch(setUserInfo(modifiedUserInfo));
      } else {
        const stackingUserInfo = await stakingContract?.userInfo(
          stackingPoolId,
          account
        );
        const modifiedUserInfo = {
          ...stackingUserInfo,
          id: stackingPoolId,
          isFixed,
        };

        dispatch(setUserInfo(modifiedUserInfo));
      }
    } catch (e) {}
  }
);

export const getTotalAllowance = createAsyncThunk(
  "stackingContract/getTotalAllowance",
  async (params, {dispatch, getState}) => {
    const {account, provider} = params;
   
    const stakedTokenContract = new ethers.Contract(
      stakedTokenAddress,
      stakedTokenABI,
      provider
    );

    const totalAllowance = await stakedTokenContract?.allowance(
      account,
      StakingAddress
    );
    console.log("durdu", totalAllowance.toString());
    return Number(totalAllowance.toString());
  }
);

export const getTotalBalance = createAsyncThunk(
  "stackingContract/getTotalBalance",
  async (params, {dispatch, getState}) => {
    const {account, provider} = params;

    const stakedTokenContract = new ethers.Contract(
      stakedTokenAddress,
      stakedTokenABI,
      provider
    );

    const totalBalance = await stakedTokenContract?.balanceOf(account);
    return Number(totalBalance.toString());
  }
);
export const canWithdraw = createAsyncThunk(
  "stackingContract/canWithdraw",
  async (params, {dispatch, getState, rejectWithValue}) => {
    const {poolId, account} = params;
    try {
      const stakingContract = getState().stakingSlice.contract;
      const allStakingPoolLength = await stakingContract?.canWithdraw(poolId);
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const fetchStakingAllPools = createAsyncThunk(
  "stackingContract/fetchStackingAllPools",
  async (stakingContract) => {
    try {
     
        let newPool = [];
        let indices = [];
        let tempPoolItem = {};

        const poolLength = await stakingContract?.getLenghtPool();
        for (let i = 0; i < poolLength; i++) {
          indices.push(i);
        }
        // need replace when contract have getter all pools.
        for await (const i of indices) {
          const poolItem = await stakingContract?.poolInfo(i);
          if (poolItem.isInitizilated === true) {
            tempPoolItem = {...poolItem};
            tempPoolItem["id"] = i;
            newPool.push({...tempPoolItem});
          }
        }
        return newPool;
      
    } catch (e) {
      console.log("error", e);
    }
  }
);

export const enableSelectedContract = createAsyncThunk(
  "stackingContract/enableSelectedContract",
  async (params, {dispatch, getState, rejectWithValue}) => {
    try {
      const {stakedTokenABI, approveAmount, account, provider} = params;

      const signer = provider.getSigner();

      const selectedPoolContract = new ethers.Contract(
        stakedTokenAddress,
        stakedTokenABI,
        signer
      );
      const tx = await selectedPoolContract.approve(
        StakingAddress,
        approveAmount.toString(10)
      );
      await tx.wait();
      window.location.reload();
      return true;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const depositSelectedContract = createAsyncThunk(
  "stackingContract/depositSelectedContract",
  async (params, {dispatch, getState, rejectWithValue}) => {
    try {
      const {selectedPoolId, amount, isFixed, account, provider} = params;
      const infoObj = {
        stackingPoolId: selectedPoolId,
        account,
        isFixed: isFixed,
      };
      const stakingContract = getState().stakingSlice.contractWithUser;
    
      if (isFixed) {
        const tx = await stakingContract.deposit(selectedPoolId, amount, {
          gasLimit: 310000,
          gasPrice: provider.getGasPrice(),
          nonce: null,
        });
        await tx.wait();
        window.location.reload();
        // await dispatch(getContractUserInfo(infoObj));
      } else {
        const tx = await stakingContract.deposit(selectedPoolId, amount, {
          gasLimit: 310000,
          gasPrice: provider.getGasPrice(),
          nonce: null,
        });
        await tx.wait();
        window.location.reload();
        return tx;
      }
    } catch (err) {
      return rejectWithValue(err?.response);
    }
  }
);

// export const depositFixedSelectedContract = createAsyncThunk(
//   "stackingContract/depositFixedSelectedContract",
//   async (params, { dispatch, getState, rejectWithValue }) => {
//     try {
//       const { selectedFixedPoolId, fixedAmount } = params;
//       const stakingContract = getState().stakingSlice.contractWithUser;
//       const provider = new ethers.providers.Web3Provider(window.ethereum);
//       await stakingContract.fixedDeposit(selectedFixedPoolId, fixedAmount, {
//         gasLimit: 310000,
//         gasPrice: provider.getGasPrice(),
//         nonce: null,
//       });
//       return true;
//     } catch (err) {
//       return rejectWithValue(err);
//     }
//   }
// );

export const emergencyWithdrawSelectedContract = createAsyncThunk(
  "stackingContract/emergencyWithdrawSelectedContract",
  async (params, {dispatch, getState, rejectWithValue}) => {
    try {
      const {selectedPoolId, isFixed, provider} = params;
      const stakingContract = getState().stakingSlice.contractWithUser;
      if (isFixed) {
        const tx = await stakingContract.emergencyWithdraw(selectedPoolId, {
          gasLimit: 310000,
          gasPrice: provider.getGasPrice(),
          nonce: null,
        });
        await tx.wait();
        window.location.reload();
      } else {
        const tx = await stakingContract.emergencyWithdraw(selectedPoolId, {
          gasLimit: 310000,
          gasPrice: provider.getGasPrice(),
          nonce: null,
        });
        await tx.wait();
        window.location.reload();
      }

      return true;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const withdrawSelectedContract = createAsyncThunk(
  "stackingContract/withdrawSelectedContract",
  async (params, {dispatch, getState, rejectWithValue}) => {
    try {
      const {selectedPoolId, withdrawAmount, isFixed, provider} = params;
      const stakingContract = getState().stakingSlice.contractWithUser;
      if (isFixed) {
        const tx = await stakingContract.withdraw(selectedPoolId, {
          gasLimit: 310000,
          gasPrice: provider.getGasPrice(),
          nonce: null,
        });
        await tx.wait();
        window.location.reload();
      } else {
        const tx = await stakingContract.withdraw(
          selectedPoolId,
          withdrawAmount,
          {
            gasLimit: 310000,
            gasPrice: provider.getGasPrice(),
            nonce: null,
          }
        );
        await tx.wait();
        window.location.reload();
      }
      return true;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const harvestSelectedContract = createAsyncThunk(
  "stackingContract/harvestSelectedContract",
  async ({selectedPoolId, provider}, {dispatch, getState, rejectWithValue}) => {
    try {
      const stakingContract = getState().stakingSlice.contractWithUser;
      const tx = await stakingContract.harvest(selectedPoolId, {
        gasLimit: 310000,
        gasPrice: provider.getGasPrice(),
        nonce: null,
      });
      await tx.await();
      return true;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);
export const updateSelectedPool = createAsyncThunk(
  "stackingContract/updateSelectedPool",
  async (params, {dispatch, getState, rejectWithValue}) => {
    try {
      const {updatePoolId, selectedPoolId, provider} = params;
      const stakingContract = getState().stakingSlice.contractWithUser;

      await stakingContract.transferPoolNativeToOther(
        selectedPoolId,
        updatePoolId,
        {
          gasLimit: 310000,
          gasPrice: provider.getGasPrice(),
          nonce: null,
        }
      );
      return true;
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const stakingSlice = createSlice({
  name: "stakingData",
  initialState: {
    contract: {},
    contractWithUser: {},
    isContractLoading: false,
    stackingPools: [],
    isStackingPoolsLoading: false,
    stakingContractFeeInfo: {},
    allStakingPools: [],
    selectedCardObj: null,
    contractUserInfo: [],
    totalAllowance: null,
    totalBalance: null,
    isEnableLoadingObj: {
      enableLoading: false,
      id: null,
      isFixed: null,
    },
    isDepositLoadingObj: {
      depositLoading: false,
      id: null,
      isFixed: null,
    },
    isEmergencyWithdrawLoadingObj: {
      emergencyWithdrawLoading: false,
      id: null,
      isFixed: null,
    },
    isWithdrawLoadingObj: {
      withdrawLoading: false,
      id: null,
      isFixed: null,
    },
    isHarvestLoadingObj: {
      harvestLoading: false,
      id: null,
      isFixed: null,
    },
  },
  reducers: {
    setSelectedCardId: (state, action) => {
      state.selectedCardObj = action.payload;
    },
    setIsEnableLoading: (state, action) => {
      const newObj = {...state.isEnableLoadingObj, ...action.payload};
      state.isEnableLoadingObj = newObj;
    },
    setIsDepositLoading: (state, action) => {
      const newObj = {...state.isDepositLoadingObj, ...action.payload};
      state.isDepositLoadingObj = newObj;
    },
    setIsWithdrawLoading: (state, action) => {
      const newObj = {...state.isWithdrawLoadingObj, ...action.payload};
      state.isWithdrawLoadingObj = newObj;
    },
    setIsEmergencyWithdrawLoading: (state, action) => {
      const newObj = {
        ...state.isEmergencyWithdrawLoadingObj,
        ...action.payload,
      };
      state.isEmergencyWithdrawLoadingObj = newObj;
    },
    setIsHarvestLoading: (state, action) => {
      const newObj = {
        ...state.isHarvestLoadingObj,
        ...action.payload,
      };
      state.isHarvestLoadingObj = newObj;
    },
    setUserInfo: (state, action) => {
      const arrContractUserInfo = [...state.contractUserInfo];
      // const isDataExist = arrContractUserInfo.find(
      //   (x) =>
      //     x.id === action.payload.id && x.isFixed === action.payload.isFixed
      // );
      // if (!isDataExist) {
      //   arrContractUserInfo.push(action.payload);
      // }
      arrContractUserInfo.push(action.payload);

      state.contractUserInfo = arrContractUserInfo;
    },
  },
  extraReducers: {
    [fetchStakingContract.fulfilled]: (state, action) => {
      state.contract = action.payload;
      state.isContractLoading = true;
    },
    [fetchStakingContract.pending]: (state, action) => {
      state.isContractLoading = false;
    },
    [fetchStakingContract.rejected]: (state, action) => {
      state.error = action.payload.errorMessage;
      state.isContractLoading = true;
    },
    [fetchStakingContractWithUser.fulfilled]: (state, action) => {
      state.contractWithUser = action.payload;
    },
    [fetchStakingAllPools.fulfilled]: (state, action) => {
      state.stackingPools = action.payload;
      state.isStackingPoolsLoading = true;
    },
    [fetchStakingAllPools.pending]: (state, action) => {
      state.isStackingPoolsLoading = false;
    },
    [fetchStakingAllPools.rejected]: (state, action) => {
      state.error = action.payload.errorMessage;
      state.isStackingPoolsLoading = true;
    },
    [getTotalAllowance.fulfilled]: (state, action) => {
      state.totalAllowance = action.payload;
    },
    [getTotalBalance.fulfilled]: (state, action) => {
      state.totalBalance = action.payload;
    },
    [getAllStakingPools.fulfilled]: (state, action) => {
      state.allStakingPools = action.payload;
    },

    [enableSelectedContract.fulfilled]: (state, action) => {
      state.isEnableLoadingObj.enableLoading = false;
    },
    [enableSelectedContract.pending]: (state, action) => {
      state.isEnableLoadingObj.enableLoading = true;
    },
    [enableSelectedContract.rejected]: (state, action) => {
      state.isEnableLoadingObj.enableLoading = false;
    },
    [depositSelectedContract.fulfilled]: (state, action) => {
      state.isDepositLoadingObj.depositLoading = false;
    },
    [depositSelectedContract.pending]: (state, action) => {
      state.isDepositLoadingObj.depositLoading = true;
    },
    [depositSelectedContract.rejected]: (state, action) => {
      state.isDepositLoadingObj.depositLoading = false;
    },
    [emergencyWithdrawSelectedContract.fulfilled]: (state, action) => {
      state.isEmergencyWithdrawLoadingObj.emergencyWithdrawLoading = false;
    },
    [emergencyWithdrawSelectedContract.pending]: (state, action) => {
      state.isEmergencyWithdrawLoadingObj.emergencyWithdrawLoading = true;
    },
    [emergencyWithdrawSelectedContract.rejected]: (state, action) => {
      state.isEmergencyWithdrawLoadingObj.emergencyWithdrawLoading = false;
    },
    [withdrawSelectedContract.fulfilled]: (state, action) => {
      state.isWithdrawLoadingObj.withdrawLoading = false;
    },
    [withdrawSelectedContract.pending]: (state, action) => {
      state.isWithdrawLoadingObj.withdrawLoading = true;
    },
    [withdrawSelectedContract.rejected]: (state, action) => {
      state.isWithdrawLoadingObj.withdrawLoading = false;
    },
    [harvestSelectedContract.fulfilled]: (state, action) => {
      state.isHarvestLoadingObj.harvestLoading = false;
    },
    [harvestSelectedContract.pending]: (state, action) => {
      state.isHarvestLoadingObj.harvestLoading = true;
    },
    [harvestSelectedContract.rejected]: (state, action) => {
      state.isHarvestLoadingObj.harvestLoading = false;
    },
  },
});

export const {
  setSelectedCardId,
  setIsEnableLoading,
  setUserInfo,
  setIsDepositLoading,
  setIsEmergencyWithdrawLoading,
  setIsWithdrawLoading,
  setIsHarvestLoading,
} = stakingSlice.actions;
export default stakingSlice.reducer;
